import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-757c322b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Noticias Ave María", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref, onMounted ,Ref} from 'vue'
import NotificationService from '@/services/NotificationService';
import { useAuth } from '@/store/useAuth';
import NotificationDetail from './NotificationDetail.vue';
import useWindowWidth from '@/composables/useWindowWidth';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationView',
  setup(__props) {

const notificationService = new NotificationService()
const loading = ref(true)
const notifications:Ref<any> = ref([])
const store = useAuth()
const showNot = ref(false)
const notTitle = ref('')
const notContent = ref('')
const notId = ref(0)
const notesResources:any = ref([])
const {windowWidth} = useWindowWidth()
const tableSmall= ref(850);

onMounted(async () => {
    if (!store.token) {
        loading.value = false
        return
    }
    loading.value = true
    notifications.value = await notificationService.ReadAllNotes(store.token)
    loading.value = false
})

const OnMarkAsRead = async (notification:string) => {
    if(store.token  != null){
    await notificationService.MarkNotificationAsRead(store.token, notification)
    loading.value = true
    notifications.value = await notificationService.ReadAllNotes(store.token)
    loading.value = false
    }

}

const OnShowMessage = async (notification:number, title:string, content:string, resources:Array<any>) => {
    notTitle.value = title
    notContent.value = content
    notId.value = notification
    notesResources.value = resources  
    showNot.value = true
}

const OnGoBack = async () => {
    if(store.token  != null){
    showNot.value = false
    loading.value = true
    notifications.value = await notificationService.ReadAllNotes(store.token)
    loading.value = false
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (showNot.value)
        ? (_openBlock(), _createBlock(NotificationDetail, {
            key: 0,
            title: notTitle.value,
            content: notContent.value,
            id: notId.value,
            resources: notesResources.value,
            onGoBack: OnGoBack
          }, null, 8, ["title", "content", "id", "resources"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    name: "ri-loader-2-fill",
                    animation: "spin",
                    class: "icon"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: notification.id,
                        style: {"margin":"5px","width":"100%"}
                      }, [
                        _createTextVNode(_toDisplayString(notification.title) + " ", 1),
                        (!notification.read && _unref(windowWidth)>tableSmall.value )
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              name: "md-newreleases-round",
                              style: {"float":"left","scale":"1.8"},
                              fill: "coral"
                            }))
                          : _createCommentVNode("", true),
                        (_unref(windowWidth)>tableSmall.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              style: {"float":"right"},
                              onClick: ($event: any) => (OnMarkAsRead(notification.id))
                            }, "Marcar como leído", 8, _hoisted_5))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          style: {"float":"right"},
                          onClick: ($event: any) => (OnShowMessage(notification.id, notification.title, notification.content, notification.resources))
                        }, "Leer mensaje", 8, _hoisted_6)
                      ]))
                    }), 128))
                  ])
                ]))
          ]))
    ]),
    _: 1
  }))
}
}

})